export default {"src":"/login-app/[GIT_HASH]/_next/static/media/close.c0a62391.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};